import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { NotificationsSession } from '@/server-events/NotificationsSession';
import { addNotifications } from '@/state/notifications/actions';
import { useAppDispatch } from '@/utils/hooks';

interface NotificationListenerProps {}

const NotificationListener: React.FC<NotificationListenerProps> = (props) => {
    const dispatch = useAppDispatch();
    const user = useSelector((state: IState) => state.global.user);

    useEffect(() => {
        if (!user?.isLoggedIn) {
            return;
        }

        const session = new NotificationsSession();

        session.addOnReceiveNotifications((data) => dispatch(addNotifications(data)));

        return function cleanup() {
            session.dispose();
        };
    }, [user, dispatch]);

    return null;
};

export default NotificationListener;
